import { FC } from 'react';
import { useGetUser } from '../../queries';
import { IAccessWrapperProps } from './types';
import { PermissionType } from 'enums/permissionType.enum';

export const AccessWrapper: FC<IAccessWrapperProps> = ({ children, accessGroups, fallback = null }) => {
  const { data: user } = useGetUser();

  const userAccessGroups = user?.roles.map(r => r.role.type) ?? [];

  const hasAccess = userAccessGroups?.some((group: PermissionType) => accessGroups.includes(group));

  return <>{hasAccess ? children : fallback}</>;
};
